<div class="flex max-h-[85vh] min-h-[200px] flex-col">
  <div
    class="border-s200 flex flex-shrink-0 items-center gap-3 border-b px-8 py-5"
  >
    <span class="text-s1 min-w-0 truncate text-lg font-medium">{{
      dataItem.diff.file
    }}</span>
    <span class="flex flex-shrink-0 items-center gap-2 text-sm">
      <span *ngIf="dataItem.diff.additions > 0" class="text-green-600"
        >+{{ dataItem.diff.additions }}</span
      >
      <span *ngIf="dataItem.diff.deletions > 0" class="text-red-600"
        >-{{ dataItem.diff.deletions }}</span
      >
      <span
        *ngIf="dataItem.diff.status"
        class="rounded px-1.5 py-0.5 text-xs"
        [ngClass]="{
          'bg-green-50 text-green-700':
            dataItem.diff.status === 'added' ||
            dataItem.diff.status === 'modified',
          'bg-red-50 text-red-700': dataItem.diff.status === 'deleted'
        }"
        >{{ dataItem.diff.status }}</span
      >
    </span>
  </div>

  <div class="flex-1 px-4 py-4">
    <div
      *ngIf="diffNotice"
      class="border-s200 bg-s100 text-s2 mb-3 rounded border px-3 py-2 text-sm"
    >
      {{ diffNotice }}
    </div>
    <diff-editor
      #diffEditor
      *ngIf="diffContent && isDiffRenderable"
      class="block w-full outline-none"
      style="height: 70vh"
      [setup]="null"
      [ngModel]="diffContent"
      [disabled]="true"
      [originalExtensions]="originalExtensions"
      [modifiedExtensions]="modifiedExtensions"
    ></diff-editor>
    <pre
      *ngIf="rawPatch"
      class="bg-s100 max-h-[65vh] overflow-auto rounded p-4 text-xs"
      >{{ rawPatch }}</pre
    >
  </div>
</div>

<div *ngIf="isHighlighterReady$ | async"></div>
